import { tss } from 'tss-react/mui';

/**
 * Shared style classes for the Device Details page and nested detail cards.
 */
const useStyles = tss.create(({ theme }) => ({
  dialogContainer: {
    backgroundColor: theme.vars.palette.transparent.a25,
    'MuiDialog-container': {
      backgroundColor: theme.vars.palette.background.elevation1
    }
  },
  statusCodeBox: {
    borderRadius: '0.5rem 0.5rem 0 0',
    padding: '0.5rem 0.5rem 0 0.5rem',
    maxWidth: 'max-content'
  },

  timeDescriptionBox: {
    borderRadius: '0 0.5rem 0.5rem 0.5rem',
    padding: '0.5rem'
  },
  collapseTableParent: {},
  collapseTableParentSelected: {
    border: `1px solid ${theme.vars.palette.primary.main}`,
    backgroundColor: theme.vars.palette.transparent.a5,
    td: {
      borderBottom: `0rem solid`
    },
    '& MuiTableCell-root': {
      borderTop: `0rem solid`
    }
  },
  collapseTableInnerWrapper: {
    td: {
      borderBottom: `0rem solid`
    }
  },
  collapseTableInner: {
    backgroundColor: theme.vars.palette.background.elevation1,
    borderBottom: '1px solid var(--mui-palette-TableCell-border)',
    '& tr th': {
      borderBottom: '0rem'
    },
    '& tr:before': {
      height: '4.75rem',
      content: '""',
      position: 'relative',
      left: '3.75rem',
      top: '0rem',
      width: '0.13rem',
      bottom: '0rem',
      display: 'flex',
      borderLeft: '0.125rem dashed',
      opacity: '.3'
    },
    '& tr:last-child:before': {
      height: '2.4rem'
    },
    '& tr td>div:first-of-type': {
      paddingLeft: '2.5rem'
    }
  },
  collapseTableInnerRow: {},
  collapseTableInnerRowSelected: {
    backgroundColor: theme.vars.palette.transparent.a10,
    border: `1px solid ${theme.vars.palette.primary.main}`
  },
  tableGroup: {
    backgroundColor: theme.vars.palette.transparent.a10
  },
  iconCollapse: {
    cursor: 'pointer',
    width: '1.375rem',
    fontSize: '1.125rem',
    alignSelf: 'center'
  },
  subDataRow: {
    '&:before': {
      height: '0.125rem',
      content: '""',
      position: 'relative',
      left: '0.125rem',
      top: '1.25rem',
      width: '1.25rem',
      bottom: '0rem',
      borderBottom: '0.125rem dashed',
      opacity: '.3'
    }
  },
  dFlex: {
    display: 'flex'
  },
  alignSelfCenter: {
    alignSelf: 'center'
  },
  deviceDetailCardHeader: {
    borderBottom: `1px solid ${theme.vars.palette.divider}`,
    fontWeight: 600,
    padding: '0.5rem 1rem',
    display: 'flex'
  },
  deviceDetailCardHeaderSpan: {
    whiteSpace: 'nowrap',
    marginTop: '0.313rem',
    // width: 'calc(100% - 12rem)',
    display: 'inline-block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '36%'
  },
  deviceDetailCardHeaderButtonWrapper: {
    float: 'inline-end',
    width: ''
  },
  deviceDetailCardHeaderButton: {
    float: 'inline-end'
  },
  deviceDetailCommon: {
    borderBottom: `1px solid ${theme.vars.palette.divider}`
  },
  deviceDetailParentcard: {
    height: '100%',
    margin: '.75rem 0',
    '&:last-child': {
      marginBottom: '3.125rem'
    }
  },
  deviceDetailCard: {
    backgroundColor: theme.vars.palette.background.elevation0,
    padding: '.75rem'
  },
  deviceDetailCardContent: {
    display: 'flex',
    marginBottom: '0.6 rem',
    '&:last-child': {
      marginBottom: '0rem'
    }
  },
  deviceChartArea: {
    backgroundColor: theme.vars.palette.background.elevation1
  },

  deviceMainTable: {
    height: '100%',
    '& th': {
      padding: '0.5rem 1rem',
      backgroundColor: theme.vars.palette.background.elevation2
    },
    '& th:first-of-type': {
      paddingLeft: '2.75rem!important'
    }
  },

  deviceHeaderSeperator: {
    borderBottom: '1px solid var(--mui-palette-TableCell-border)'
  },

  card: {
    height: '100%'
  },
  cardContent: {
    height: '100%',
    padding: '0 !important'
  },
  cardHeader: {
    borderBottom: `1px solid ${theme.vars.palette.divider}`,
    fontWeight: 600,
    padding: '0.5rem 1rem'
  },
  tableHeaderSticky: {
    position: 'sticky',
    top: '0',
    backgroundColor: theme.vars.palette.background.elevation2,
    borderBottom: `1px solid ${theme.vars.palette.background.elevation0}`,
    zIndex: '99'
  },
  ellipsisMenu: {
    '& ul': {
      backgroundColor: theme.vars.palette.background.elevation1
    },
    '& li:hover': {
      backgroundColor: theme.vars.palette.background.elevation0
    }
  },

  rowGroup: {
    margin: theme.spacing(0)
  },
  deviceTableContainer: {
    height: '100%',
    minHeight: 500,
    position: 'relative',
    boxShadow: theme.shadows[2],
    borderRadius: 4,
    backgroundColor: theme.vars.palette.background.elevation2,
    gridRow: 'span 4',
    [theme.breakpoints.down('md')]: {
      gridColumn: 'span 2',
      gridRow: 'span 1'
    },
    '& td:first-of-type': {
      width: '388px'
    },

    '& td': {
      paddingBottom: '.8rem',
      paddingTop: '.8rem'
    }
  },
  deviceDetailsCard: {
    height: '100%',
    minHeight: 500,
    position: 'relative',
    boxShadow: theme.shadows[2],
    borderRadius: 4,
    backgroundColor: theme.vars.palette.background.elevation1,
    gridRow: 'span 4',
    [theme.breakpoints.down('md')]: {
      gridColumn: 'span 2',
      gridRow: 'span 1'
    }
  },
  routeButtonTooltip: {
    backgroundColor: theme.vars.palette.background.navigation,
    fontSize: '0.875rem'
  },
  routeButtonTooltipArrow: {
    color: theme.vars.palette.background.navigation
  },
  devicesTablePagination: {
    backgroundColor: theme.vars.palette.background.elevation2,
    borderTop: `1px solid ${theme.vars.palette.border.light}`,
    bottom: 0,
    display: 'relative',
    position: 'sticky',
    zIndex: 29
  },
  deviceStatusIconStyle: {
    height: '2.75rem'
  },

  warningColor: {
    color: theme.vars.palette.warning.main
  },
  KVFlex: {
    display: 'flex',
    margin: '0.625rem 0',
    gap: '.5rem'
  }
}));

export default useStyles;
